import PropTypes from 'prop-types';
import React from 'react';
import ReactVivus from 'react-vivus';

const ContactInfoItemTwo = ({ data, classOption }) => {
  return (
    <div
      className={`contact-info ${classOption} flex items-center mb-5 p-3 bg-gray-100 rounded-lg gap-4 `}
      style={{ flexWrap: 'nowrap' }} /* Prevent wrapping */
    >
      <div className="icon flex-none w-12 sm:w-16 lg:w-20 mr-4 sm:mr-5">
        <ReactVivus
          id={`contactsvg-${data.id}`}
          option={{
            file: data.icon,
            animTimingFunction: 'EASE',
            type: 'oneByOne',
            delay: 80,
          }}
        />
      </div>
      <div className="flex-grow min-w-0">
        <h4 className="text-base sm:text-lg font-bold text-black mb-1 sm:mb-2 truncate">
          {data.title}
        </h4>
        <span
          className="info-text text-xs sm:text-sm text-gray-600 block truncate"
          dangerouslySetInnerHTML={{ __html: data.info }}
        />
      </div>
    </div>
  );
};

ContactInfoItemTwo.propTypes = {
  data: PropTypes.object.isRequired,
  classOption: PropTypes.string,
};

ContactInfoItemTwo.defaultProps = {
  classOption: 'contact-info ct-info-two',
};

export default ContactInfoItemTwo;
